<template>
    <section id="home" class="section welcome-area d-flex align-items-center">
        <div class="container">
            <div class="row align-items-center">
                <!-- Welcome Intro Start -->
                <div class="col-12 col-md-6 col-lg-6">
                    <div class="welcome-intro">
                        <h1>By Rule</h1>
                        <h3 class="fw-3 mt-2 mt-sm-3">Rule the game!</h3>
                        <p class="my-3">Learn the fundamentals of college basketball officiating with the help of this beautifully designed iOS application.</p>
                        <!-- Store Buttons -->
                        <div class="button-group store-buttons">
                            <a href="https://apps.apple.com/us/app/by-rule/id1532845521" class="btn btn-bordered">
                                <i class="icofont icofont-brand-apple dsp-tc"></i>
                                <p class="dsp-tc">AVAILABLE ON
                                    <br> <span>Apple Store</span></p>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-12 offset-2 col-md-6 col-lg-4">
                    <!-- Welcome Thumb -->
                    <div class="welcome-thumb text-center" data-aos="fade-left" data-aos-delay="500" data-aos-duration="1000">
                        <img src="assets/img/collegeCourt.jpeg" alt="">
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style>

</style>